<div class="mat-typography">
<!--
  <app-notifications></app-notifications>
-->
  <app-ads-dashboard></app-ads-dashboard>
  @if (!this.loading) {
    <app-widget-area></app-widget-area>
    <div class="tiles-area">
      @if (canAccessTile([
        'BULK_BILL_RECEIPT',
        'BULK_BILL',
        'CREDIT_NOTE',
        'VETERINARY_DRUG',
        'TRANSFUSION',
        'REIMPORT',
        'EXTENDED_BENEFIT'
      ])) {
        <div class="tile"
             routerLink="/belege">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-belege">&nbsp;</div>
          </div>
          <h4 class="text-center">Belegarchiv ></h4>
        </div>
      }

      @if (canAccessTile(['NACH'])) {
        <div class="tile"
             routerLink="/nachlieferung">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-nachlieferung">&nbsp;</div>
          </div>
          <h4 class="text-center">Nachlieferungliste ></h4>
        </div>
      }
      @if (canAccessTile(['ORDERS'])) {
        <div class="tile"
             routerLink="/shop">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-shop">&nbsp;</div>
          </div>
          <h4 class="text-center">Produktsuche ></h4>
        </div>
      }

      <div class="tile"
           routerLink="/vorbestellung/lagerware-grippe2026">
        <div class="img-box">
          <div class="d-flex jcc tile-icon icon-grippe">&nbsp;</div>
        </div>
        <h4 class="text-center">Reservierung Lagerware Grippe ></h4>
      </div>

      <div class="tile"
           routerLink="/vorbestellung-archiv"
           matBadge="UPDATE"
           matBadgeSize="medium"
           matBadgePosition="before">
        <div class="img-box">
          <div class="d-flex jcc tile-icon icon-grippe">&nbsp;</div>
        </div>
        <h4 class="text-center">Vorbestellung Archiv ></h4>
      </div>

      @if (canAccessTile(['MY_SALES'])) {
        <div class="tile"
             routerLink="/umsatz">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-umsatz">&nbsp;</div>
          </div>
          <h4 class="text-center">Umsatz ></h4>
        </div>
      }

      @if (canAccessTile(['SLIMFIT_EVALUATIONS'])) {
        <div class="tile"
             routerLink="/auswertungen"
             matBadge="NEU"
             matBadgeSize="medium"
             matBadgePosition="before">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-evaluations">&nbsp;</div>
          </div>
          <h4 class="text-center">Auswertungen ></h4>
        </div>
      }

      @if (hasConditions() && canAccessTile(['ORDERS']) || userService.isAdmin()) {
        <div class="tile"
             routerLink="/retouren"
             matBadge="NEU"
             matBadgeSize="medium"
             matBadgePosition="before">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-returns">&nbsp;</div>
          </div>
          <h4 class="text-center">Retouren ></h4>
        </div>
      }

      @if (canShowMasterDataTile) {
        <div class="tile"
             routerLink="/stammdaten">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-stammdaten">&nbsp;</div>
          </div>
          <h4 class="text-center">Kundenstammdatenüberprüfung</h4>
        </div>
      }

<!--      @if (hasConditions() && canAccessTile(['ORDERS']) || userService.isAdmin()) {-->
        <div class="tile"
             routerLink="/sendungsverfolgung-new"
             matBadge="Redesign"
             matBadgeSize="medium"
             matBadgePosition="before">
          <div class="img-box">
            <div class="d-flex jcc tile-icon icon-tracking">&nbsp;</div>
          </div>
          <h4 class="text-center">New T & T></h4>
        </div>
<!--      }-->
    </div>
  }
</div>
